import React, { FC } from "react";
import { createStyles, makeStyles, Theme, useTheme } from "@material-ui/core/styles";
import { TableContainer, Table, TableHead, TableRow, TableBody, TableCell, Typography, Grid } from "@material-ui/core";
import { GuestInfo } from "../../model/guest-info";
import { CalendarResource } from "../../model/calendarResource";
import { AppointmentsResponse } from "../../service/booking-service";
import { SELF_GUIDED_TOUR } from "../constants";
import moment from "moment-timezone";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      margin: 0,
      padding: 0,
      //            border: "1px solid lightgrey"
    },
    table: {
      width: "100%",
      minWidth: 1000,
      fontFamily: "Mallory",
      fontWeight: 600,
    },
    container: {
      maxHeight: 100,
    },
    ok: {
      color: "green",
    },
    error: {
      color: "red",
    },
  })
);

export interface ReviewAppointmentProps {
  guestInfo: GuestInfo;
  selectedResources: CalendarResource[];
  appointmentsResponse?: AppointmentsResponse;
}

const ReviewAppointment: FC<ReviewAppointmentProps> = ({ guestInfo, selectedResources, appointmentsResponse }) => {
  const classes = useStyles(useTheme());
  const [appointments, setAppointments] = React.useState<CalendarResource[]>(selectedResources);
  const [errorResponseText, setErrorResponseText] = React.useState<string>(appointmentsResponse?.statusText);

  React.useEffect(() => {
    setAppointments(selectedResources);
  }, [selectedResources]);

  React.useEffect(() => {
    let error = undefined;
    if (appointmentsResponse && appointmentsResponse.status !== 200) {
      error = appointmentsResponse.statusText;
    } else if (
      appointmentsResponse &&
      appointmentsResponse.data &&
      appointmentsResponse.data[0] &&
      appointmentsResponse.data[0].errorCode
    ) {
      error = appointmentsResponse.data[0].errorCode + ": " + appointmentsResponse.data[0].message;
    }
    setErrorResponseText(error);
  }, [appointmentsResponse]);

  return (
    <>
      {(!appointmentsResponse || appointments.length > 0) && (
        <Grid item xs={12}>
          <Typography variant="h5" style={{ marginLeft: "16px" }}>
            Review Requested Appointments
          </Typography>
          <TableContainer>
            <Table className={classes.table} aria-label="appointments table">
              <TableHead>
                <TableRow>
                  <TableCell>Tour Type</TableCell>
                  <TableCell>Neighborhood</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Time</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {appointments &&
                  appointments.map((resource) => (
                    <TableRow key={resource.id}>
                      <TableCell>{appointments[0].tourType}</TableCell>
                      <TableCell component="th" scope="row">
                        {resource.name}
                      </TableCell>
                      <TableCell>{resource.startTime.format("dddd, MMMM Do")}</TableCell>
                      <TableCell>{moment.tz(resource.startTime,'America/Los_Angeles').format("h:mm A z")}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
      {appointmentsResponse && appointments.length === 0 && (
        <Grid item xs={12}>
          <Typography variant="h5" style={{ marginLeft: "16px" }}>
            Appointments Status
          </Typography>
          <TableContainer>
            <Table className={classes.table} aria-label="response table">
              <TableHead>
                <TableRow>
                  <TableCell>Tour Type</TableCell>
                  <TableCell>Neighborhood</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Time</TableCell>
                  <TableCell>Appointment ID</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Detail</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {appointmentsResponse &&
                  appointmentsResponse.data &&
                  appointmentsResponse.data.bookingList &&
                  appointmentsResponse.data.bookingList.map((appt, index) => (
                    <TableRow key={index} className={appt.appointmentNumber ? classes.ok : classes.error}>
                      <TableCell className={appt.appointmentNumber ? classes.ok : classes.error}>{appt.tourType}</TableCell>
                      <TableCell className={appt.appointmentNumber ? classes.ok : classes.error} component="th" scope="row">
                        {appt.propertyName}
                      </TableCell>
                      <TableCell className={appt.appointmentNumber ? classes.ok : classes.error}>
                        {moment(appt.tourStartTime).format("dddd, MMMM Do")}
                      </TableCell>
                      <TableCell className={appt.appointmentNumber ? classes.ok : classes.error}>
                        {moment.tz(appt.tourStartTime,'America/Los_Angeles').format("h:mm A")}
                      </TableCell>
                      <TableCell className={appt.appointmentNumber ? classes.ok : classes.error}>{appt.appointmentNumber}</TableCell>
                      <TableCell className={appt.appointmentNumber ? classes.ok : classes.error}>{appt.status}</TableCell>
                      <TableCell className={appt.appointmentNumber ? classes.ok : classes.error}>{appt.error}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
      {errorResponseText && (
        <Grid item xs={12}>
          <Typography variant="caption" color="error">
            {errorResponseText}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default ReviewAppointment;
